export function shallowObjectEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) {
        return false;
    }
    const aObj = a;
    const bObj = b;
    return Object.keys({ ...aObj, ...bObj }).every((key) => aObj[key] === bObj[key]);
}
export function deepObjectEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (typeof a !== 'object' || typeof b !== 'object' || !a || !b) {
        return false;
    }
    const aObj = a;
    const bObj = b;
    return Object.keys({ ...aObj, ...bObj }).every((key) => deepObjectEqual(aObj[key], bObj[key]));
}
//# sourceMappingURL=obj-equal.js.map